<template>
  <b-form-group v-bind="commonFormGroupProps">
    <b-form-file
        :value="value"
        @input="$emit('input', $event)"
        :multiple="item.multiple"
        :placeholder="item.placeHolder || (item.multiple ? 'Choose files or drop them here...' : 'Choose a file or drop it here...')"
        :drop-placeholder="item.dropPlaceHolder || (item.multiple ? 'Drop files here...' : 'Drop file here...')"
    />
  </b-form-group>
</template>

<script>
import { formMixin } from '@/mixins/formMixin'

export default {
  mixins: [formMixin],
  props: ['item', 'value'],
  computed: {
    commonFormGroupProps () {
      return {
        ...this.getCommonFormGroupProps()
      }
    }
  }
}
</script>